<template>
  <div class="container is-fluid">
    <section class="section">
      <h1 class="title">{{ $t('userSettings.title') }}</h1>
      <p>{{ $t('userSettings.subtitle') }}</p><br />

      <h3 class="title is-5">{{ $t('userSettings.wialonToken') }}</h3>
      <p>{{ $t('userSettings.wialonTokenDescription') }}</p><br />

      <b-button @click="getAccessToken" class="is-primary">
        {{ $t('userSettings.updateButtonText') }}
      </b-button>
    </section>
  </div>
</template>

<script>

import shared from '@/utils.js';
const axios = require('axios');

import { EventBus, globalEvents } from '@/event-bus/event-bus.js';

export default {
  name: "UserSettings",
  components: {},
  data: function () {
    return {
      api: axios.create({
        baseURL: process.env.VUE_APP_JOBS_API_ROOT,
        headers: { Authorization: `Bearer ${localStorage.backendToken}` }
      })
    }
  },
  methods: {
    getAccessToken: function () {
      shared.getAccessToken();
    }
  },
  created: function () {
    let dashboard = this;

    EventBus.$on(globalEvents.wialonTokenUpdated, (wialonAccessToken) => {
      this.api.post(`update-wialon-token/${wialonAccessToken}`).then(response => {
        if (response.status == 200) {
          dashboard.$buefy.toast.open({
            message: this.$t('userSettings.tokenUpdated'),
            type: "is-success"
          })
        } else {
          dashboard.$buefy.toast.open({
            message: this.$t('userSettings.tokenUpdateError'),
            type: "is-danger"
          })
        }
      }).catch(function () {
        dashboard.$buefy.toast.open({
          message: this.$t('userSettings.tokenUpdateError'),
          type: "is-danger"
        })
      });
    });
  }
};

</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .button {
    width: 100%;
  }
}
</style>